import { render, staticRenderFns } from "./secondReviewList_wx.vue?vue&type=template&id=44001b83&scoped=true"
import script from "./secondReviewList_wx.vue?vue&type=script&lang=js"
export * from "./secondReviewList_wx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44001b83",
  null
  
)

export default component.exports